// import {DodgerBlueColor} from '../../cmsMainStyle'

const userGroupFormStyle = theme => ({
	groupFieldPaper: {
		padding: theme.spacing(1),
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(5),
	},

	groupFieldText: {
		'& .MuiTextField-root': {
			marginTop: theme.spacing(1),
			marginBottom: theme.spacing(1),
		},
	},
})

export {userGroupFormStyle}